import {IOS_DEVICES} from '../../states/dashboard/main/main.settings';

export function requireImage(imageFileName: string, useNewInterface: boolean = false) {
    return require(`img/${useNewInterface ? 'new-interface-assets/' : ''}${imageFileName}`);
}

export function isRemoteClientAndroid(clientOs: string | undefined | null): boolean {
    const pattern = new RegExp(IOS_DEVICES.ANDROID, 'i');

    return !!clientOs && pattern.test(clientOs);
}

export class UriUtils {
    static safeDecode(val: string | null): string | undefined {
        if (!val) return undefined;
        try {
            return decodeURIComponent(val).trim();
        } catch {
            return val.trim();
        }
    }
}
